import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.legacy_reading_source_ */
export type LegacyReadingSourceId = string & {
  __brand: 'LegacyReadingSourceId'
}

/** Represents the table public.legacy_reading_source_ */
export default interface LegacyReadingSourceTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<
    LegacyReadingSourceId,
    LegacyReadingSourceId,
    LegacyReadingSourceId
  >

  /** Database type: pg_catalog.text */
  description: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>
}

export type LegacyReadingSource = Selectable<LegacyReadingSourceTable>

export type LegacyReadingSourceInitializer =
  Insertable<LegacyReadingSourceTable>

export type LegacyReadingSourceMutator = Updateable<LegacyReadingSourceTable>

export const legacyReadingSourceId =
  z.string() as unknown as z.Schema<LegacyReadingSourceId>

export const legacyReadingSource = z.object({
  id: legacyReadingSourceId,
  description: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<LegacyReadingSource>

export const legacyReadingSourceInitializer = z.object({
  id: legacyReadingSourceId,
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<LegacyReadingSourceInitializer>

export const legacyReadingSourceMutator = z.object({
  id: legacyReadingSourceId.optional(),
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<LegacyReadingSourceMutator>
